export default __webpack_public_path__ + "static/media/ato_rika_tristes.ad14c9d5.svg";